import {Inject, Injectable} from '@angular/core';
import {RestEndPoints, ServerConstants, UserService} from "common-domain";
import {HttpClient} from "@angular/common/http";
import {AuthService, CreatePasswordCommand, ResetPasswordCommand} from "common-domain";
import {AppConfigService} from 'common-domain';

@Injectable({
  providedIn: 'root'
})
export class TldManagerUserService extends UserService {


  constructor(@Inject(HttpClient) http, @Inject('env') environment, @Inject(AuthService) auth, @Inject(AppConfigService) config) {
    super(http, environment, auth, config);
  }

  initResetPassword(userName: string) {
    const url = this.getRestEndPoint() + RestEndPoints.RESET_PASSWORD;
    return this.getPostResponseUnAuthenticatedRequest(url, userName);
  }

  resetOrCreatePassword(newPassword: string, correlationId: string, create: boolean, mfaToken: string) {
    if (create) {
      return this.createPassword(newPassword);
    } else {
      return this.resetPassword(newPassword, correlationId, mfaToken);
    }
  }

  resetPassword(newPassword: string, correlationId: string, mfaTokenJwt: string) {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;
    const resetPasswordCommand: ResetPasswordCommand = {};
    resetPasswordCommand.newPassword = newPassword;
    resetPasswordCommand.correlationId = correlationId;
    if (mfaTokenJwt) {
      resetPasswordCommand.mfaTokenJwt = mfaTokenJwt;
    }
    return this.getPostResponseUnAuthenticatedRequest(url, this.createCommandEnvelope(resetPasswordCommand, ServerConstants.RESET_PASSWORD_COMMAND));
  }

  private createPassword(newPassword: string) {
    const url = this.getRestEndPoint() + RestEndPoints.COMMON_COMMAND;
    const createPasswordCommand: CreatePasswordCommand = {};
    createPasswordCommand.newPassword = newPassword;
    return this.getPostResponseUnAuthenticatedRequest(url, this.createCommandEnvelope(createPasswordCommand, ServerConstants.CREATE_PASSWORD_COMMAND));
  }

  recoveryUserName(email: string, password: string) {
    const url = this.getRestEndPoint() + RestEndPoints.RECOVER_USERNAME;

    let requestObj = {
      email: email,
      password: password
    };
    return this.getPostResponseUnAuthenticatedRequest(url, requestObj);
  }


  getCurrentUserFromHeaderToken() {
    const url = this.getRestEndPoint() + RestEndPoints.GET_CURRENT_USER_UNAUTHENTICATED_REQUEST;
    return this.getResponseUnAuthenticatedRequest(url);
  }
}
